import React from "react";
import Info from "../img/Info.svg";
import { useTranslation } from "react-i18next";

const RFCDisclaimer = () => {
  const { t } = useTranslation(["consultations"]);
  return (
    <div
      className="e2e-prescription-rfc-disclaimer"
      style={{
        backgroundColor: "#FFFAF2",
        padding: 5,
        marginBottom: 10,
        marginTop: 10,
        fontWeight: "bold",
        display: "flex",
        flexDirection: "row",
        fontSize: "12px",
        gap: 5,
      }}
    >
      <div>
        <img src={Info} alt="" width={40} />
      </div>
      <div>{t("prescriptionRfcDisclaimerMessage")}</div>
    </div>
  );
};

export default RFCDisclaimer;
